import React, { useState } from "react";
import Authentication from "services/Authentication";
import notify from "utils/toastMsg";
import {
  Form,
  InputNonOptimized,
  ErrorMessage,
  SubmitButton,
} from "components/Forms";
import confirmForgotPasswordSchema from "./schemas/confirmForgotPasswordSchema";

let auth = new Authentication();

const ConfirmForgotPassword = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formValues) => {
    const { email, code, newPassword } = formValues;
    try {
      setLoading(true);
      await auth.confirmForgotPassword({ email, code, newPassword });
      setMessage("Password has been reset successfully.");
      notify(`Redirecting to Login page... ✅`);
      setError("");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2500);
    } catch (err) {
      setError(
        "Failed to reset password. Make sure the verification code is correct."
      );
      notify(
        `Failed to reset password. Make sure the verification code is correct. ❌`
      );
      setLoading(false);
    }
  };

  return (
    <div>
      <img className="login-logo" src="assets/images/ll2.png" alt="logo" />
      <div
        className="mt-5"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="col-lg-5 mt-5">
          <div className="card mb-0 mt-5">
            <div className="card-body">
              <div className="mb-4 text-center">
                <h3 className="mb-0" style={{ fontFamily: "Poppins" }}>
                  Reset Password
                </h3>
              </div>
              <Form
                className="form-horizontal mt-5"
                initialValues={{
                  email: "",
                  code: "",
                  newPassword: "",
                }}
                validationSchema={confirmForgotPasswordSchema}
                onSubmit={handleSubmit}
              >
                <div className="form-group row">
                  <div className="col-12 mt-4 d-flex justify-content-center align-items-center">
                    {" "}
                    <InputNonOptimized
                      className="mb-2 form-control"
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                    />
                  </div>
                  <ErrorMessage name="email" />
                </div>
                <div className="form-group row">
                  <div className="col-12 mt-4 d-flex justify-content-center align-items-center">
                    {" "}
                    <InputNonOptimized
                      className="mb-2 form-control"
                      type="text"
                      placeholder="Enter verification code"
                      name="code"
                    />
                  </div>
                  <ErrorMessage name="code" />
                </div>
                <div className="form-group row">
                  <div className="col-12 mt-4 d-flex justify-content-center align-items-center">
                    {" "}
                    <InputNonOptimized
                      className="mb-2 form-control"
                      type="password"
                      placeholder="Enter new password"
                      name="newPassword"
                    />
                  </div>
                  <ErrorMessage name="newPassword" />
                </div>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <SubmitButton
                  className="m-2 btn btn-primary btn-lg"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                </SubmitButton>
              </Form>
              {message && <p>{message}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmForgotPassword;
